import type { LangFn } from '../../../hooks/useLang';

export function formatAuthError(lang: LangFn, authError?: string) {
  if (!authError) {
    return undefined;
  }

  const translated = lang(authError);
  const message = translated !== authError ? translated : authError;
  return message.replace(/\n+/g, ' ').trim();
}
